import React from 'react'
import { AuthContext } from '../Contexts/AuthContext'

export default function useIsAuthenticated(): boolean {
  const authContext = React.useContext(AuthContext)

  return authContext !== null
}
